/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod_Exp_BadgeInputs */

const es_landing_mod_exp_badge = /** @type {(inputs: Landing_Mod_Exp_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const gl_landing_mod_exp_badge = /** @type {(inputs: Landing_Mod_Exp_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiencias`)
};

const en_landing_mod_exp_badge = /** @type {(inputs: Landing_Mod_Exp_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar Experiences`)
};

/**
* | output |
* | --- |
* | "Zarpar Experiences" |
*
* @param {Landing_Mod_Exp_BadgeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod_exp_badge = /** @type {((inputs?: Landing_Mod_Exp_BadgeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod_Exp_BadgeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod_exp_badge(inputs)
	if (locale === "en") return en_landing_mod_exp_badge(inputs)
	return es_landing_mod_exp_badge(inputs)
});